'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const DiagramStore = require('system/domain/repository/diagram');
const ElementStore = require('system/domain/repository/element');
const MemberModel = require('common/domain/entity/member');
const OwnerListViewTemplate = require('system/ui/template/owner/list.hbs');
const OwnerItemViewTemplate = require('system/ui/template/owner/item.hbs');

const OwnerItemView = Mn.View.extend({
    model: MemberModel,
    tagName: 'li',
    className: 'list-item owner-list-item',
    template: OwnerItemViewTemplate,
    ui: {
        ownedNodes: '.owned-nodes'
    },
    events: {
        'click @ui.ownedNodes': 'showOwnedNodes',
        'click': 'toggle'
    },
    modelEvents: {
        'change': 'render'
    },

    initialize: function(options) {
        this._context = options.context;
        this._diagramContext = options.diagramContext;
    },

    templateContext: function() {
        const j = this.model.getUser().toJSON();

        // Diagram 内で表示されている場合は Owner のノード数と詳細を表示する
        if(this._diagramContext) {
            this._nodes = null;
            const diagram = DiagramStore.getDiagrams({
                context: this._diagramContext
            }).get(this._diagramContext.diagramId);
            j.nodes = ElementStore.getNodes({
                context: this._diagramContext
            })
                .chain()
                .filter(function(m){ return diagram.hasNode(m); })
                .filter(function(m){
                    return _.contains(m.get('owners'),
                        this.model.getUserID().toString());
                }, this)
                .value();
            j.hasNode = j.nodes.length > 0;
            j.nodeNum = j.nodes.length;
        }

        return j;
    },

    onRender: function() {
        if(this.model.get('deleted')) {
            this.close();
            return;
        }
        if(this.model.selected()) {
            this.activate();
        } else {
            this.deactivate();
        }
        return this;
    },

    showOwnedNodes: function(evt) {
        const name = this.model.getUser().getName();
        const id = this.model.getUserID().toString().substring(0, 6);
        this.getOption('channel').request('search',
            `owner:"${name}"(#${id})`);
        evt.stopPropagation();
    },

    activate: function() {
        this.$el.addClass('is-active');
    },

    deactivate: function() {
        this.$el.removeClass('is-active');
    },

    toggle: function() {
        this.model.toggle();
    }
});

/**
 * @exports views/diagram/sidebar/owner-list-view
 */
const OwnerListView = Mn.CompositeView.extend(
    /**
     * @lends module:views/diagram/sidebar/owner-list-view.OwnerListView.prototype
     */
    {
        className: 'owners',
        template: OwnerListViewTemplate,
        childView: OwnerItemView,
        childViewContainer: '.owner-list',
        childViewOptions: function() {
            return {
                context: this.getOption('context'),
                channel: this.getOption('channel'),
                diagramContext: this.getOption('diagramContext')
            }
        }
    });

module.exports = OwnerListView;



// WEBPACK FOOTER //
// ./system/ui/view/owner/list.js